// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__z3PDI","right":"styles_right__17ImA"};